import React from "react";
import { Col, Input, Row, Select, Typography } from "antd";
import { useTranslation } from "react-i18next";

import { insuranceFields } from "../../fieldNames";
import { FormItem } from "../../../../components";
import { onlyWhitespacesRule, zipInputRules } from "../../../../utils";
import { States } from "../../../../../../../constant/states";
import { stateOptionsSearch } from "../../../../../../../utils/search";
import { SingleSelect } from "../../../../../../customComponent/CustomSelect";

const { Option } = Select;
const { Text } = Typography;

export const MedicarePartDDetails = () => {
  const { t } = useTranslation();
  return (
    <>
      <div style={{ marginBottom: 10 }}>
        <Text strong>{t("application_form_editor.pfizer.insurance.labels.medicare_part_d_insurance_only")}</Text>
      </div>
      <Row gutter={14}>
        <Col span={24}>
          <FormItem
            name={insuranceFields.partDAddress}
            label={t("application_form_editor.pfizer.insurance.labels.part_d_address")}
            rules={[onlyWhitespacesRule, { required: true }]}
          >
            <Input placeholder={t("application_form_editor.pfizer.insurance.placeholders.part_d_address")} />
          </FormItem>
        </Col>
      </Row>
      <Row gutter={14}>
        <Col span={8}>
          <FormItem
            name={insuranceFields.partDCity}
            label={t("application_form_editor.pfizer.insurance.labels.city")}
            rules={[onlyWhitespacesRule, { required: true }]}
          >
            <Input placeholder={t("application_form_editor.pfizer.insurance.placeholders.city")} />
          </FormItem>
        </Col>
        <Col span={8}>
          <FormItem
            name={insuranceFields.partDState}
            rules={[{ required: true }]}
            label={t("application_form_editor.pfizer.insurance.labels.state")}
          >
            <SingleSelect
              useCommonStyle={false}
              bordered={true}
              placeholder={t("application_form_editor.pfizer.insurance.placeholders.state")}
              getPopupContainer={(trigger) => trigger.parentNode}
              filterOption={stateOptionsSearch}
            >
              {Object.values(States).map((state, index) => (
                <Option key={index} value={state.code}>
                  {state.name}
                </Option>
              ))}
            </SingleSelect>
          </FormItem>
        </Col>
        <Col span={8}>
          <FormItem
            rules={[...zipInputRules, onlyWhitespacesRule, { required: true }]}
            name={insuranceFields.partDZip}
            label={t("application_form_editor.pfizer.insurance.labels.zip_code")}
          >
            <Input
              maxLength={5}
              style={{ width: "100%" }}
              placeholder={t("application_form_editor.pfizer.insurance.placeholders.zip_code")}
            />
          </FormItem>
        </Col>
      </Row>
    </>
  );
};
